module.exports = __webpack_public_path__ + "static/media/DSC04823-2.cf737192.png";